import { injectGlobal } from 'styled-components';

injectGlobal`
  #root {
    box-sizing: border-box;
    font-size: 12px;
    margin: 0;
    padding: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/global.js